import { render, staticRenderFns } from "./FinishGroup.vue?vue&type=template&id=64cbda6b&scoped=true&"
import script from "./FinishGroup.vue?vue&type=script&lang=ts&"
export * from "./FinishGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FinishGroup.vue?vue&type=style&index=0&id=64cbda6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbda6b",
  null
  
)

export default component.exports